<template>
  <div>
    <p class="description">
      This page lists users with access to the Survey Insights tab in the
      <a
        href="/app/insights/demographic-survey-report?tab=survey"
        target="_blank"
        rel="noopener noreferrer"
      >
        Demographic Survey Report
      </a>
      which shows analytics around candidate demographics.
      Learn more about the report
      <a
        href="#"
        data-beacon-article-sidebar="67e70efe5cad390a94c0469d"
        @click.stop
      >
        here.
      </a>
    </p>
    <AdminTable
      v-if="demographicSurveyUsers.length || listLoading"
      class="mt-4"
      :admins="demographicSurveyUsers"
      :loading="listLoading"
      show-remove-access-button
      :current-user-id="currentUserId"
      @remove-access="removeAccess"
    />
    <RemoveAccessModal
      v-model="showRemoveAccessModal"
      :user-to-remove="userToRemove"
      @removed-user="handleRemovedUser"
    />
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import { useSettingsTeam } from '@/stores/settings/team';
import { storeToRefs } from 'pinia';
import AdminTable from '@/components/settings/team/AdminTable.vue';
import RemoveAccessModal from '@/components/settings/team/RemoveAccessModal.vue';
import { useAppLoading } from '@/stores/app/loading';
import { useAppAuthData } from '@/stores/app/authData';
import { useAppSnackbar } from '@/stores/app/snackbar';

const emit = defineEmits(['track-page-load']);

const userToRemove = ref(null);
const showRemoveAccessModal = ref(false);

const { listLoading } = storeToRefs(useAppLoading());
const { demographicSurveyUsers } = storeToRefs(useSettingsTeam());
const { authData } = storeToRefs(useAppAuthData());
const { addSnackbar } = useAppSnackbar();

const { loadDemographicSurveyUsers, setDemographicSurveyUsers } = useSettingsTeam();

const currentUserId = computed(() => authData.value?.userId);

onMounted(() => {
  emit('track-page-load', { page: 'Demographic Report Permissions' });

  return loadDemographicSurveyUsers();
});

const removeAccess = (user) => {
  userToRemove.value = user;
  showRemoveAccessModal.value = true;
};

const handleRemovedUser = (userId) => {
  addSnackbar({
    text: `${userToRemove.value?.email || 'The user'} has had full report access removed`,
    color: 'success',
  });

  setTimeout(() => {
    userToRemove.value = null;
  }, 500);

  const newUsers = demographicSurveyUsers.value.filter((user) => user.id !== userId);
  setDemographicSurveyUsers(newUsers);
};
</script>

<style scoped lang="less">
.description {
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  color: @text-darkest;

  a {
    color: @text-brand;
    cursor: pointer;
  }
}
</style>
